import { useEffect } from 'react';

export const useClickOutside = (ref, callbackFn, ...extraRef) => {
  const checkForOutsideClick = event => {
    let isClickedOutside = true;

    if (
      ref.current instanceof HTMLElement &&
      ref.current.contains(event.target)
    ) {
      isClickedOutside = false;
    }

    extraRef.forEach(currentRef => {
      if (
        currentRef.current instanceof HTMLElement &&
        currentRef.current.contains(event.target)
      ) {
        isClickedOutside = false;
      }
    });
    return isClickedOutside;
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (checkForOutsideClick(event)) {
        callbackFn();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callbackFn]);
};
